<template>
  <div>
    <div class="login-page">
      <top></top>
      <div class="box">
        <div class="services">
          <div class="container">
            <div class="services-mian">
              <h3>ABOUT US</h3>

              <p>成熟团队运作,专业可靠的技术底蕴。</p>
              <p>百余家企业、近万位产品用户的认可。</p>
              <!-- <p>易奇签到一站式连接主办方、参会者。</p> -->
            </div>
          </div>
        </div>
        <div class="text-center"
             style="margin-top: 30px">
          <img src="https://img.eqlee.com/upload/woyou/20161104/apply_support.png" />
        </div>
        <div class="text-center"
             style="margin-top: 30px">
          <img src="https://img.eqlee.com/upload/woyou/20161104/apply_value.png" />
        </div>
        <div class="about"
             id="about">
          <div class="container">
            <div class="about-main">
              <h3>立即申请合作</h3>
              <p></p>
              <div style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                ">
                <el-form ref="form"
                         :rules="rules"
                         :model="form"
                         label-width="80px">
                  <el-form-item label="姓名"
                                style="width: 500px"
                                prop="name">
                    <el-input v-model="form.name"></el-input>
                  </el-form-item>
                  <el-form-item label="手机号"
                                style="width: 500px"
                                prop="tel">
                    <el-input v-model="form.tel"></el-input>
                  </el-form-item>
                  <el-form-item label="邮箱"
                                style="width: 500px"
                                prop="email">
                    <el-input v-model="form.email"></el-input>
                  </el-form-item>
                  <el-form-item label="内容"
                                style="width: 500px"
                                prop="infoContent"
                                v-model="form.infoContent">
                    <el-input type="textarea"
                              v-model="form.infoContent"></el-input>
                  </el-form-item>
                  <el-form-item label-width="0px">
                    <el-button type="primary"
                               @click="onSubmit">提交申请</el-button>
                  </el-form-item></el-form>
              </div>
            </div>
            <imageAuthen :visible="imageVisible"
                         @close="imageVisible = false"
                         @enter="enter"></imageAuthen>
          </div>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import Foot from "./_foot";
import top from "./_top_menu";
import imageAuthen from "@/components/imageAuthen";
export default {
  components: {
    Foot,
    top,
    imageAuthen,
  },
  data () {
    let validatePhone = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号不正确"));
      } else {
        callback();
      }
    };
    let validateEmail = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码
      if (!/^\w+@[a-z0-9]+\.[a-z]+$/.test(value)) {
        callback(new Error("邮箱格式不正确"));
      } else {
        callback();
      }
    };
    return {
      form: {},
      imageVisible: false,
      rules: {
        name: [{ required: true, message: "请输入您的姓名", trigger: "blur" }],
        email: [
          { required: true, message: "请输入您的邮箱", trigger: "blur" },
          { validator: validateEmail, trigger: "blur" },
        ],
        infoContent: [
          { required: true, message: "请输入内容", trigger: "blur" },
        ],
        tel: [
          { required: true, message: "请输入您的手机号", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" },
        ],
      },
    };
  },
  created () { },

  directives: {
    focus: {
      // 指令的定义
      inserted: function (el) {
        el.focus();
      },
    },
  },

  methods: {
    goBack () {
      this.$router.push("/login");
    },
    onSubmit () {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.imageVisible = true;
        } else {
          return false;
        }
      });
    },
    enter (v) {
      let sendData = {
        name: this.form.name,
        tel: this.form.tel,
        email: this.form.email,
        uuid: v.uuid,
        vierificationCode: v.captcha,
        infoContent: this.form.infoContent,
      };
      this.$api.manage.ApplyEdit(sendData).then((res) => {
        if (res.code === 0) {
          this.form = {};
          this.$message.success("提交成功");
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.login-page {
  width: 100%;
  background-color: #fff;
  // height: 100vh;
  .loginBtn {
    cursor: pointer;
  }

  .services {
    background: url("https://img.eqlee.com/upload/woyou/20161104/service-banner.jpg")
      no-repeat;
    background-size: 100% 100%;
    min-height: 500px;
    .container {
      width: 1170px;
      padding-right: 15px;
      padding-left: 15px;
      margin-right: auto;
      margin-left: auto;
    }
    .container:before {
      display: table;
      content: " ";
    }
    .services-mian {
      text-align: center;
      border: 2px solid #fff;
      padding: 3em 0px;
      width: 80%;
      margin: 12% auto 0;
      position: relative;
      p {
        color: #fff;
        font-weight: 400;
        font-size: 16px;
        width: 63%;
        margin: 3% auto 0;
        line-height: 1.6em;
      }
      h3 {
        color: #fff;
        font-size: 34px;
        font-weight: 600;
        letter-spacing: 3px;
        margin: 0;
        position: absolute;
        background: rgba(172, 183, 203, 1);
        top: -17px;
        left: 27%;
        width: 45%;
      }
    }
  }
  .text-center {
    text-align: center;
    img {
      vertical-align: middle;
    }
  }
  .about {
    padding: 6em 0px;
    .container {
      width: 1170px;
      padding-right: 15px;
      padding-left: 15px;
      margin-right: auto;
      margin-left: auto;
    }
    .about-main {
      text-align: center;
      border: 2px solid #3c3c3c;
      padding: 3em 0px;
      width: 80%;
      margin: 0 auto;
      position: relative;

      h3 {
        color: #3c3c3c;
        font-size: 34px;
        font-weight: 600;
        letter-spacing: 3px;
        margin: 0;
        position: absolute;
        background: #fff;
        top: -17px;
        left: 27%;
        width: 45%;
      }
      p {
        color: #3c3c3c;
        font-weight: 400;
        font-size: 16px;
        width: 85%;
        margin: 3% auto 0;
        line-height: 1.6em;
      }
    }
  }
}
</style>
